module.exports = __webpack_public_path__ + "media/images/350x150-5-d89b056f1f0c8b7499c57cd6127555a4.jpg";